import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import api from "../../services/api";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import SearchWrapDiv from "../../components/common/SearchWrapDiv";
import SearchButton from "../../components/common/SearchButton";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import DashboardDiv from "../../components/common/DashboardDiv";
import ListWrapDiv from "../../components/common/ListWrapDiv";
import PageBar from "../../components/common/PageBar";
import CodeSelectBox from "../../components/common/CodeSelectBox";
import ActiveButton from "../../components/common/ActiveButton";
import CustomDropDownTreeSelect from "../../components/common/CustomDropDownTreeSelect";
import CustomDatePicker from "../../components/common/CustomDatePicker";
import { useMenuAuthInfo } from "../../services/GlobalUtil";
import { useTranslation } from "react-i18next";
import LoadingBoxDiv from "../../components/common/LoadingBoxDiv";

const DeviceManagementPage = () => {
  const menuAuthInfo = useMenuAuthInfo();
  const { t } = useTranslation();
  const pageSize = 12;

  const [curPage, setCurPage] = useState(1);
  const [totalCount, setTotalCount] = useState();

  const [startDate, setStartDate] = useState(
    moment().subtract(1, "year").toDate()
  );
  const [endDate, setEndDate] = useState(moment().toDate());
  const [status, setStatus] = useState(null);
  const [locationDlr, setLocationDlr] = useState([]);
  const searchRegion = useRef([]);
  const searchStatus = useRef("");
  const searchStartDt = useRef(moment().subtract(1, "year").toDate());
  const searchEndDt = useRef(moment().toDate());

  const sbStatus = [
    { code: null, codeDesc: t("L0673") },
    { code: true, codeDesc: t("L0315") },
    { code: false, codeDesc: t("L0316") },
  ];
  const [sbLocationDlr, setSbLocationDlr] = useState([]);

  const [dash, setDash] = useState([]);
  const [datas, setDatas] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const loadLocationLocData = () => {
    if (sbLocationDlr != null && sbLocationDlr.length > 0) {
      return;
    }

    api
      .post("/common/location-loc-tree", {})
      .then((response) => {
        setSbLocationDlr(response.data);
      })
      .catch(() => {});
  };

  const loadContentData = () => {
    setIsLoading(true);

    api
      .post("/manage/device/stat", {
        sLocationLocs: searchRegion.current,
        sStatus: searchStatus.current,
        sStartDate: moment(searchStartDt.current).format("YYYY-MM-DD"),
        sEndDate: moment(searchEndDt.current).format("YYYY-MM-DD"),
      })
      .then((response) => {
        setDash(response.data);
      })
      .catch(() => {});
    api
      .post("/manage/device/view", {
        sLocationLocs: searchRegion.current,
        sStatus: searchStatus.current,
        sStartDate: moment(searchStartDt.current).format("YYYY-MM-DD"),
        sEndDate: moment(searchEndDt.current).format("YYYY-MM-DD"),
        page: curPage,
        size: pageSize,
      })
      .then((response) => {
        setDatas(response.data.content);
        setTotalCount(response.data.totalCount);
        setIsLoading(false);
      })
      .catch(() => {});
  };

  useEffect(() => {
    if (menuAuthInfo.view) {
      loadContentData();
    }
  }, [curPage]);

  const handleSearch = () => {
    searchRegion.current = locationDlr;
    searchStatus.current = status;
    searchStartDt.current = startDate;
    searchEndDt.current = endDate;

    if (curPage === 1) {
      loadContentData();
    } else {
      setCurPage(1);
    }
  };

  const pageChange = (data) => {
    if (curPage === data) {
      return;
    }
    setCurPage(data);
  };

  const handleStatusChange = (e) => {
    if (e.target.value === t("L0673")) {
      setStatus(null);
    } else {
      setStatus(e.target.value === "true");
    }
  };

  const handleStatusClick = (id) => {
    api
      .post("/manage/device/update-status", {
        id: id,
      })
      .then(() => {
        loadContentData();
      })
      .catch(() => {});
  };

  const handleStartDateChange = (data) => {
    setStartDate(data);
    if (moment(data).isAfter(moment(endDate))) {
      setEndDate(data);
    }
  };

  const handleEndDateChange = (data) => {
    setEndDate(data);
    if (moment(data).isBefore(moment(startDate))) {
      setStartDate(data);
    }
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("MENU:L0056"), t("MENU:L0280")]}></BreadCrumbDiv>

      <SearchWrapDiv>
        <ButtonWrapDiv>
          <CustomDropDownTreeSelect
            data={sbLocationDlr}
            placeholder={t("L0049")}
            isViewCode={true}
            flattenIntermediate={true}
            onChange={setLocationDlr}
            onFocus={loadLocationLocData}
          ></CustomDropDownTreeSelect>
          <CodeSelectBox
            value={status}
            codes={sbStatus}
            onChange={handleStatusChange}
            isCodeVisible={false}
            multiple={false}
          ></CodeSelectBox>
        </ButtonWrapDiv>
        <ButtonWrapDiv className="btn_right">
          <CustomDatePicker
            defaultDate={startDate}
            maxDate={new Date()}
            onChange={(date) => handleStartDateChange(date)}
            dateFormat={"YYYY-MM-dd"}
          ></CustomDatePicker>
          <div>
            <br />
            &nbsp;&nbsp;-&nbsp;&nbsp;
          </div>
          <CustomDatePicker
            defaultDate={endDate}
            maxDate={new Date()}
            onChange={(date) => handleEndDateChange(date)}
            dateFormat={"YYYY-MM-dd"}
          ></CustomDatePicker>
          <SearchButton onClick={handleSearch}></SearchButton>
        </ButtonWrapDiv>
      </SearchWrapDiv>

      <LoadingBoxDiv loading={isLoading}>
        <DashboardDiv>
          <dl>
            <dt>{t("L0310")}</dt>
            <dd>{dash.deviceCnt}</dd>
          </dl>
          <dl>
            <dt>{t("L0117")}</dt>
            <dd>{dash.distCnt}</dd>
          </dl>
          <dl>
            <dt>{t("L0118")}</dt>
            <dd>{dash.portCnt}</dd>
          </dl>
          <dl>
            <dt>{t("L0119")}</dt>
            <dd>{dash.dealCnt}</dd>
          </dl>
          <dl>
            <dt>{t("L0315")}</dt>
            <dd>{dash.activeCnt}</dd>
          </dl>
          <dl>
            <dt>{t("L0316")}</dt>
            <dd>{dash.disableCnt}</dd>
          </dl>
        </DashboardDiv>

        <ListWrapDiv>
          <table>
            <colgroup>
              <col style={{ width: "4%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "auto" }} />
              <col style={{ width: "15%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "10%" }} />
            </colgroup>
            <thead>
              <tr>
                <th>{t("L0130")}</th>
                <th>{t("L0312")}</th>
                <th>{t("L0313")}</th>
                <th>{t("L0314")}</th>
                <th>{t("L0048")}</th>
                <th>{t("L0049")}</th>
                <th>{t("L0049")}</th>
                <th>{t("L0051")}</th>
                <th>{t("L0105")}</th>
                <th>{t("L0673")}</th>
              </tr>
            </thead>
            <tbody>
              {datas.length === 0 ? (
                <tr>
                  <td colSpan={11} style={{ textAlign: "center" }}>
                    {t("L0094")}
                    <br />
                    {t("L0095")}
                  </td>
                </tr>
              ) : (
                datas.map((data, rowIndex) => (
                  <tr key={rowIndex}>
                    <td>{data.rowNum}</td>
                    <td>{data.deviceId}</td>
                    <td>{data.model}</td>
                    <td>{data.mac}</td>
                    <td>{t(`AREA:${data.area}`)}</td>
                    <td>{t(`UNITED:${data.united}`)}</td>
                    <td>{t(`CNTRY:${data.country}`)}</td>
                    <td>{data.loc}</td>
                    <td>{data.locDesc}</td>
                    <td>
                      <ActiveButton
                        onClick={
                          menuAuthInfo.edit
                            ? () => handleStatusClick(data.id)
                            : undefined
                        }
                        isActive={data.active}
                        style={{
                          cursor: menuAuthInfo.edit ? "pointer" : "default",
                        }}
                      ></ActiveButton>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </ListWrapDiv>

        <PageBar
          TotalCount={totalCount}
          CurrentPage={curPage}
          CountPerPage={pageSize}
          MaxPageBarCount={10}
          onPageСhange={pageChange}
        ></PageBar>
      </LoadingBoxDiv>
    </div>
  );
};

export default DeviceManagementPage;
